export const getOffsetFromPageNumber = (number, size) => {
  return (number - 1) * size;
}